import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  setSessionValue(key: string, value: any) {
    sessionStorage.setItem(key, value);
  }

  getSessionValue(key: string, type?: string, subType?: string) {
    if (type === 'json') {
      if (sessionStorage.getItem(key) !== null && sessionStorage.getItem(key) !== '') {
        return JSON.parse(sessionStorage.getItem(key).replace(/\\/g, ''));
      }
      if (subType === 'array') {
        return [];
      }
      return {};
    } else if (sessionStorage.getItem(key) !== null && sessionStorage.getItem(key) !== '') {
      return sessionStorage.getItem(key);
    }
    return null;
  }

  setLocalValue(key: string, value: any) {
    localStorage.setItem(key, value);
  }

  getLocalValue(key: string, type?: string, subType?: string) {
    if (type === 'json') {
      if (localStorage.getItem(key) !== null && localStorage.getItem(key) !== '') {
        return JSON.parse(localStorage.getItem(key).replace(/\\/g, ''));
      }
      if (subType === 'array') {
        return [];
      }
      return {};
    } else if (localStorage.getItem(key) !== null && localStorage.getItem(key) !== '') {
      return localStorage.getItem(key);
    }
    return null;
  }

  removeLocalValue(key: string) {
    localStorage.removeItem(key);
  }

  removeSessionValue(key: string) {
    sessionStorage.removeItem(key);
  }
}
